import {FormikContextType, useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {SponsorBottomSheetProps} from '../type';
import useGetInitialSponsorInformation from '../../../../../services/hookService/sponsor/getInitialSponsorInformation/useGetInitialSponsorInformation';
import { initialValuesSponsorForm } from '../../../CreateActivePlan/type';
import { sponsorFormatNumber } from '../../../../../utilities/helper/SponsorFormatNumber';

const SponseringPackageBottomSheet = ({
  show,
  setShow,
}: SponsorBottomSheetProps) => {
  const {sponsorInfo, isLoading} = useGetInitialSponsorInformation();
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();
  return (
    <BottomSheet
      onDismiss={() => setShow(false)}
      open={show}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
      className="custom-bottom-sheet"
    >
      <div className="p-6 flex flex-col gap-[29px] text-gray-900">
        {/* start header bottom sheet */}
        <div className="flex items-center justify-between ">
          <h5>تعداد پیام</h5>
          <SpanIcon
            className="icon-nameClose-remove text-gray-700 text-2xl"
            onClick={() => setShow(false)}
          />
        </div>
        {/* end header bottom sheet */}
        <ul className="space-y-2 overflow-y-scroll mb-0 pl-0 max-h-[60dvh]">
          {!isLoading &&
            sponsorInfo?.sponsering_package.map((item, index) => (
              <li
                className="flex items-center gap-1"
                key={'sponser-message-item' + index}
                onClick={() => {
                  formikProps.setFieldValue('sponsering_package', {
                    title: `${sponsorFormatNumber(item.sms_count)} پیام`,
                    id: item.id,
                  });
                  formikProps.setFieldTouched('sponsering_package', true);
                  formikProps.setFieldValue(
                    'price',
                    item.minimum_bid_amount.payment_amount,
                  );
                  formikProps.setFieldValue('ipg_type', sponsorInfo.ipg_type);
                  setShow(false);
                }}
              >
                <span
                  className={`w-3 h-3 !rounded !border ${
                    formikProps.values.sponsering_package.id === item.id
                      ? 'bg-farm-shop-500 !border-farm-shop-500'
                      : 'bg-transparent !border-gray-800'
                  }`}
                ></span>
                <span>{`${sponsorFormatNumber(item.sms_count)} پیام`}</span>
              </li>
            ))}
        </ul>
      </div>
    </BottomSheet>
  );
};

export default SponseringPackageBottomSheet;
